import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAnnuitySurvivorBenefitType } from './monthly-pension-annuity-survivor-benefit-type';
import { MonthlyPensionJointLifeAnnuityCalculationItem } from './monthly-pension-joint-life-annuity-calculation-item';

export class MonthlyPensionJointLifeAndSurvivorBenefit implements Deserializable {
  public survivorBenefit!: MonthlyPensionAnnuitySurvivorBenefitType;
  public annuityCalculations!: MonthlyPensionJointLifeAnnuityCalculationItem[];

  public onDeserialize(): void {
    if (!!this.survivorBenefit) {
      this.survivorBenefit = window.injector.Deserialize.instanceOf(
        MonthlyPensionAnnuitySurvivorBenefitType,
        this.survivorBenefit
      );
    }
    this.annuityCalculations = window.injector.Deserialize.arrayOf(
      MonthlyPensionJointLifeAnnuityCalculationItem,
      this.annuityCalculations
    );
  }
}
